// USA
export const locale = {
    lang: 'en',
    data: {

        TRANSLATOR: {
            SELECT: 'Select your language',
        },
        MENU: {
            NEW: 'new',
            ACTIONS: 'Actions',
            CREATE_POST: 'Create New Post',
            REPORTS: 'Reports',
            APPS: 'Apps',
            DASHBOARD: 'Dashboard'
        },
        OFFER: {
            OPT: {
                FAIL: 'Unable to update the offer selection',
                SUCCESS: 'Offer selection is updated successfully'
            }
        },
        AUTH: {
            GENERAL: {
                OR: 'Or',
                SUBMIT_BUTTON: 'Submit',
                NO_ACCOUNT: 'Don\'t have an account?',
                SIGNUP_BUTTON: 'Signup',
                FORGOT_BUTTON: 'Forgot Password',
                BACK_BUTTON: 'Back',
                PRIVACY: 'Privacy',
                LEGAL: 'Legal',
                CONTACT: 'Contact',
            },
            LOGIN: {
                TITLE: 'Login Account',
                BUTTON: 'Sign In',
            },
            FORGOT: {
                TITLE: 'Forgotten Password?',
                DESC: 'Enter your email to reset your password',
            },
            REGISTER: {
                TITLE: 'Sign Up',
                DESC: 'Enter your details to create your account',
                SUCCESS: 'Your account has been successfuly registered. Please use your registered account to login.'
            },
            INPUT: {
                EMAIL: 'Email',
                FULLNAME: 'Fullname',
                PASSWORD: 'Password',
                CONFIRM_PASSWORD: 'Confirm Password',
            },
            VALIDATION: {
                INVALID: '{{name}} is not valid',
                REQUIRED: '{{name}} is required',
                MIN_LENGTH: '{{name}} minimum length is {{min}}',
                AGREEMENT_REQUIRED: 'Terms & conditions need to be accepted',
                NOT_FOUND: 'The requested {{name}} is not found',
                INVALID_LOGIN: 'The login details are incorrect'
            }
        },
        MESSAGES: {
            OFFERS: {
                LENDER_APPROVED_NO_RATES: {
                    TITLE: 'Thank you for completing the application!',
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.'
                },
                NO_BUREAU_REPORT: {
                    TITLE: 'We are sorry!',
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.'
                },
                NO_BUREAU_HIT_COBORROWER: {
                    TITLE: '',
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.'
                },
                PEND: {
                    TITLE: 'Your Application is Under Review',
                    MESSAGE: 'We will contact you within 1 business day regarding the status of your application.'
                },
                CROSS_SELL_DISCLOSURE: {
                    MESSAGE: ''
                },
                NO_OFFER: {
                    TITLE: 'We are sorry!',
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.',
                },
                NO_OFFER_NO_HIT: {
                    TITLE: 'We are sorry!',
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.'
                },
                NO_OFFER_HARD_DECLINE: {
                    TITLE: 'We are sorry!',
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.'
                },
                NO_OFFER_SOFT_DECLINE: {
                    TITLE: 'We are sorry!',
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.'
                },
                NO_OFFER_FRAUD_DECLINE: {
                    TITLE: `Sorry, We're Not Able to Open Your Account at This Time`,
                    MESSAGE: ''
                },
                FRAUD: {
                    TITLE: `Sorry, We're Not Able to Open Your Account at This Time`,
                    MESSAGE: ''
                },
                NO_OFFER_WITH_LTV: {
                    TITLE: 'Contact us',
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.'
                },
                NO_OPTIONS: {
                    MESSAGE: 'Unfortunately we are unable to find a product that is suitable for you. You can contact us at {{phoneNumber}}.'
                },
                PAYMENT_EXAMPLE: {
                    MESSAGE: 'Payment Example: Monthly payments for a $10,000 loan at 3.19% APR with a term of 4 ' +
                        'years would result in 48 monthly payments of $222.18. Total interest paid over full term ' +
                        'of the loan will be $664.64.'
                },
                APR_LEGAL_NOTE: {
                    MESSAGE: 'The Annual Percentage Rate (APR) is the yearly rate at which your loan accrues interest. ' +
                        'Rates will vary based on your credit, loan size and type of collateral is provided, with the ' +
                        'lower rates may be available to customers with good credit on vehicles with low loan to ' +
                        'values ratios. Minimum and maximum loan amounts and APR may vary according to state law ' +
                        'and are subject to change.'
                },
                PRE_QUALIFIED_OFFER: {
                    MESSAGE: 'These Pre-Qualified offers are based on the information you provided and in your credit file. ' +
                        'They are initial, conditional offers and are subject to change based on completion of a final application, ' +
                        'verification of information you provided, and other conditions determined solely by the lender. ' +
                        'The offers above are not guaranteed and not a commitment to lend.'
                },
                PROVISIONING_COMPLETE: {
                    TITLE: 'You are all set.',
                    MESSAGE: 'Congratulations on making a great financial choice. You are all set and we will be contacting ' +
                        'you within the next 72 business hours. If you find a ' +
                        'need to get in touch with us, do not hesitate to contact us at {{phoneNumber}}',
                },
                PROVISIONING_ENDED: {
                    TITLE: 'Your Application is Under Review.',
                    MESSAGE: 'We will contact you within 1 business day regarding the status of your application.',
                },
                FINANCIAL_SUBMITTED: {
                    TITLE: 'Thank you for completing the application!',
                    MESSAGE: 'We really appreciate your business and opportunity to serve you. One of our expert Member Service Representatives will be ' +
                        'contacting you in the next 1-2 business days with the next steps. ' +
                        'You can reach us at {{phoneNumber}} if you have any questions in the meanwhile.'
                },
                ACCOUNT_SUBMITTED: {
                    TITLE: 'Thank you for completing the application!',
                    MESSAGE: 'We really appreciate your business and opportunity to serve you. One of our expert Member Service Representatives will be ' +
                        'contacting you in the next 1-2 business days with the next steps. ' +
                        'You can reach us at {{phoneNumber}} if you have any questions in the meanwhile.'
                },
                PRE_FINANCIAL_SUBMITTED: {
                    TITLE: 'Thank you for completing the application!',
                    MESSAGE: 'We really appreciate your business and opportunity to serve you. One of our expert Member Service Representatives will be ' +
                        'contacting you in the next 1-2 business days with the next steps. ' +
                        'You can reach us at {{phoneNumber}} if you have any questions in the meanwhile.'
                },
                OFFER_SELECTED: {
                    TITLE: 'Contact us',
                    MESSAGE: 'These offers are based on the information you provided and in your credit file. ' +
                        'They are initial, conditional offers and are subject to change based on completion of a final application, ' +
                        'verification of information you provided, and other conditions determined solely by the lender. ' +
                        'The offers above are not guaranteed and not a commitment to lend.'
                }
            },
            CASH_APPLICATION: {
                TITLE: 'Thank you for completing the application!',
                MESSAGE: 'We really appreciate your business and opportunity to serve you. One of our Representatives will be contacting' +
                    ' you in the next 1-2  business days with the next steps. ' +
                    'You can reach us at {{phoneNumber}} if you have any questions in the meanwhile.'
            },
            FINANCIAL_SUBMITTED: {
                TITLE: 'Thank you for completing the application!',
                MESSAGE: 'We really appreciate your business and opportunity to serve you. we will be ' +
                    'contacting you in the next 1-2 business days with the next steps. ' +
                    'You can reach us at {{phoneNumber}} if you have any questions in the meanwhile.'
            },
            ACCOUNT_SUBMITTED: {
                TITLE: 'Thank you for completing the application!',
                MESSAGE: 'We really appreciate your business and opportunity to serve you. One of our expert Member Service Representatives will be ' +
                    'contacting you in the next 1-2 business days with the next steps. ' +
                    'You can reach us at {{phoneNumber}} if you have any questions in the meanwhile.'
            },
            PRE_FINANCIAL_SUBMITTED: {
                TITLE: 'Thank you for completing the application!',
                MESSAGE: 'We really appreciate your business and opportunity to serve you. One of our expert Member Service Representatives will be ' +
                    'contacting you in the next 1-2 business days with the next steps. ' +
                    'You can reach us at {{phoneNumber}} if you have any questions in the meanwhile.'
            },
            FINANCIAL_SUBMITTED_FAILED: {
                TITLE: 'Thank you for completing the application!',
                MESSAGE: 'We really appreciate your business and opportunity to serve you. we will be ' +
                    'contacting you in the next 1-2 business days with the next steps. ' +
                    'You can reach us at {{phone}} if you have any questions in the meanwhile.'
            },
            YOUTH_KID_ACCOUNT: {
                TITLE: 'Thank you for completing the application!',
                MESSAGE: 'To complete this Youth Kid Account application, a parent or guardian must visit one of our branches ' +
                    'in person or call us at {{phoneNumber}}. We look forward to seeing you!'
            },
            EXCEPTION: {
                TITLE: 'Oops, something unexpected happened!',
                MESSAGE: 'Our expert  Member Service Representatives will be able to take care of you. Please call ' +
                    'the number listed above to speak to your dedicated advisor.'
            },
            DISCLOSURE: {
                FINAL: {
                    CONSENT_1: 'You are providing written consent under the Fair Credit Reporting Act to authorize qualified lending ' +
                        'partners of ABC Lender to',
                    CONSENT_2: 'obtain your credit report with a hard credit inquiry ',
                    CONSENT_3: ' from credit reporting agencies. You acknowledge that this is an application for credit and authorize Innovative Funding ' +
                        'Services’s lending partners to obtain such information solely to evaluate your credit application. ' +
                        'By clicking this box, you consent, acknowledge, and agree that ABC Lender, on your behalf, may forward your credit ' +
                        'application and the results of your application to affiliated/non-affiliated third parties such as other ' +
                        'automobile lenders that may assist you in obtaining vehicle financing. You are also consenting to allow our ' +
                        'partners to offer you savings and benefits on other products.'
                },
                SOFT_INQUIRY: {
                    CONSENT_1: ' You are providing express written consent under the Fair Credit Reporting Act to authorize ' +
                        'ABC Lender to obtain your credit profile from credit reporting agencies. ' +
                        'You authorize ABC Lender to obtain such information solely to evaluate ' +
                        'your eligibility for certain loan product pre-qualification offers and acknowledge ' +
                        'that this is not a final application for credit.',
                    CONSENT_UPTO_LENDER: 'You are providing express written consent to share your information with ' +
                        'up to five (5) selected qualifying lending partners, or an authorized third party ' +
                        'on their behalf, to communicate with you about loans.',
                    CONSENT_PRIVACY: 'You agree that you received the ABC Lender <a ' +
                        'href="https://abc-cx.creditsnap.com/privacy-policy/" target="_new" class="cs-link">Privacy Policy</a>. ' +
                        'You also verified that you can read and print or keep these electronic documents and you ' +
                        'certify that your selections and information in this form are true, correct and complete.',
                    CONSENT_MARKETING: 'I hereby consent to receive email, SMS or other marketing communications from ABC Lender ' +
                        'and its trusted lending partners. I further expressly agree that ABC Lender as well as any arranger of ' +
                        'credit or creditor, who receives my information, may contact me at the calling numbers providing including ' +
                        'my cellular number, vi alive, auto dialer, prerecorded telephone call, text chat or email message. ' +
                        'I further understand that my telephone company may impose charges on me for these contacts and I am not ' +
                        'required to provide this consent to be effective even if my calling numbers or email address are included on ' +
                        'ado-not-call list or registry. I understand that my consent to receive calls is not required in order to ' +
                        'purchase any goods or services. If you do not want to receive any marketing communications just un-check the box.'
                },
                MARKETING_INQUIRY: {
                    CONSENT_MARKETING_1: 'I hereby consent to receive email, SMS or other marketing communications from ABC Lender. ' +
                        'I further expressly agree that ABC Lender ',
                    CONSENT_MARKETING_2: ' may contact me at the calling numbers providing including my cellular number, via live, ' +
                        'auto dialer, prerecorded telephone call, text, chat or email message. I further understand that my telephone ' +
                        'company may impose charges on me for these contacts and I am not required to provide this consent to be effective even if ' +
                        'my calling numbers or email address are included on a do-not-call list or registry. I understand that my ' +
                        'consent to receive calls is not required in order to purchase any goods or services. ' +
                        'If you do not want to receive any marketing communications just un-check the box'
                }
            }
        }
    }
};
